// extracted by mini-css-extract-plugin
module.exports = {"not_found":"not-found-page_not_found___o9Iq","title":"not-found-page_title___hox6","btn":"not-found-page_btn__0lOXU","main_img":"not-found-page_main_img__R9lVE"};